import script from "./RefrescosView.vue?vue&type=script&setup=true&lang=js"
export * from "./RefrescosView.vue?vue&type=script&setup=true&lang=js"

import "./RefrescosView.vue?vue&type=style&index=0&id=28508df1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28508df1"]])

export default __exports__